<template>
    <div>
        <el-form ref="form" :model="form" label-width="140px">
            <el-row :gutter="10" class="mb8">
                <el-col :span="24">
                    <el-form-item label="同时发布至知识库：" prop="name">
                        <a>{{this.workspace_name}} </a>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10" class="mb8">
                <el-col :span="24">
                    <el-form-item label="选择文件：" prop="name">
                        <div class="upload-container">
                            <!-- 未选择文件时的上传区域 -->
                          <div v-if="!form.uploadFile" class="upload-area">
                            <input
                                type="file"
                                id="uploadFile"
                                ref="uploadFile"
                                accept=".pdf,.xlsx,.xls,.txt,.pptx,.ppt"
                                @change="handleFileUpload"
                                class="file-input"/>
                            <label for="uploadFile" class="upload-box">
                                <div v-if="!form.uploadFile" class="upload-placeholder">
                                    <span class="plus-icon">+</span>
                                    <span class="upload-text">点击上传文档</span>
                                </div>
                                <div v-else class="file-preview" @click.stop> <!-- 添加阻止事件冒泡 -->
                                    <template>
                                        <span class="file-icon">📄</span>
                                        <span class="file-name">{{ form.uploadFile.name }}</span>
                                    </template>
                                    <button type="button" class="remove-btn" @click.stop="removeFile">×</button>
                                </div>
                            </label>
                          </div>

                            <!-- 已选择文件时的预览区域 -->
                            <div v-else class="preview-area">
                                <div class="file-preview">
                                    <span class="file-icon">📄</span>
                                    <span class="file-name">{{ form.uploadFile.name }}</span>
                                    <button type="button" class="remove-btn" @click="removeFile">×</button>
                                </div>
                            </div>
                            <p class="form-note">文档库是您的资料库，但是AI客服并不能使用其中的文档。只有发布到知识库的文档才能被AI客服使用。
                                以后可以选择从文档库发布文档到知识库，无需重复上传。</p>
                                <p style="color: red;">**如果知识库中已有同名文档，则会覆盖原有文档。请提前核查**</p>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <!-- 添加上传进度条 -->
            <el-row v-if="isUploading || uploadProgress > 0" :gutter="10" class="mb8">
                <el-col :span="24">
                    <el-form-item label="上传进度：">
                        <el-progress
                            :percentage="uploadProgress"
                            :status="uploadError ? 'exception' : (uploadProgress === 100 ? 'success' : undefined)"
                            :stroke-width="8"
                            :show-text="true"
                        />
                        <div class="upload-status">
                            <div class="uploading-text" v-if="isUploading && uploadProgress < 100">
                                <i class="el-icon-loading"></i>
                                文件上传中，请稍候...
                            </div>
                            <div class="success-text" v-else-if="uploadProgress === 100">
                                <i class="el-icon-success"></i>
                                上传完成！
                            </div>
                            <div class="error-text" v-else-if="uploadError">
                                <i class="el-icon-error"></i>
                                {{ uploadError }}
                            </div>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

     <script>
     import { getDefaultFolder,is_document_exist_in_folder,
         uploadToOSS, triggerAnythingLLMProcess  }
         from "@/api/aics/KbDocument.js";

     export default {
         name: "AnythingllmUploadDocument",
         props: {
           workspace_slug: {
             type: String,
             default: ''
           },
           tenantId: {
             type: Number,
             default: 0
           },
           userName: {
            type: String,
            default: ''
           },
           workspace_name: {
             type: String,
             default: ''
           },
           dirId: {
            type: Number,
            default: 0
           },

         },
         data() {
           return {

            loading: true,
            defaultFolder: '',
            title: "",
            open: false,
            dirs: [],
            form: {
               uploadFile: null,
             },
             uploadProgress: 0, // 上传进度
             isUploading: false, // 上传状态
             uploadError: '', // 错误信息
             folder_name: '', // 目标文件夹
           };
         },

         mounted() {
            console.log("AnythingllmUploadDocument - 组件挂载", this.userName, this.tenantId, this.dirId);
            getDefaultFolder(this.tenantId).then(response => {
                console.log("getDefaultFolder - 结果:", response);
                if (response.code === 200) {
                    this.defaultFolder = response.message;
                    this.form.folder_name = this.defaultFolder;

                } else {
                    this.defaultFolder = '';
                }
                });
         },
         methods: {

            getProgressStatus() {
                if (this.uploadError) {
                    return 'exception';
                } else if (this.uploadProgress === 100) {
                    return 'success';
                } else {
                    return undefined;
                }
            },
            handleFileUpload(event) {
                const file = event.target.files[0]
                if (file) {
                    // Validate file size (max 2MB)
                    if (file.size > 2 * 1024 * 1024) {
                    this.$message.error('文件大小不能超过2MB')
                    return
                    }

                    this.form.uploadFile = file
                }
                return false; // 阻止表单提交
            },

            removeFile(event) {
              if (event) {
                 event.preventDefault();
                 event.stopPropagation();
              }
              this.form.uploadFile = null;
              if (this.$refs.uploadFile) {
                  this.$refs.uploadFile.value = '';
               }
           },
           validateForm() {
                return new Promise((resolve) => {
                    if (this.form.folder_name === "") {
                        this.$message.error("请选择目标目录");
                        resolve(false);
                        return;
                    }
                    if (this.form.uploadFile === null) {
                        this.$message.error("请选择文件");
                        resolve(false);
                        return;
                    }
                    if (this.form.uploadFile.size > 2 * 1024 * 1024) {
                        this.$message.error("文件大小不能超过2MB");
                        resolve(false);
                        return;
                    }

                    console.log("this.form.uploadFile:", this.form.uploadFile);
                    is_document_exist_in_folder(this.form.uploadFile.name, this.form.folder_name, this.tenantId).then(response => {
                        console.log("is_document_exist_in_folder - 结果:", response);
                        if (response.data.code === 200) {
                            if (response.data.data) {
                                this.$confirm("文件已存在，是否覆盖？", "提示", {
                                    confirmButtonText: "确定",
                                    cancelButtonText: "取消",
                                    type: "warning"
                                }).then(() => {
                                    console.log("覆盖文件");
                                    resolve(true); // 用户确认覆盖
                                }).catch(() => {
                                    console.log("用户取消覆盖");
                                    resolve(false); // 用户取消覆盖
                                });
                            } else {
                                resolve(true); // 文件不存在，可以上传
                            }
                        } else {
                            this.$message.error(response.message);
                            resolve(false);
                        }
                    }).catch(error => {
                        console.error("检查文件是否存在失败:", error);
                        this.$message.error("检查文件是否存在失败");
                        resolve(false);
                    });
                });
            },
            async submitForm() {
                this.form.folder_name = "folder_" + this.tenantId;
                console.log("uploadFile:", this.form.uploadFile);

                // 先进行基础验证
                if (this.form.uploadFile === null) {
                    this.$message.error("请选择文件");
                    return false;
                }
                if (this.form.uploadFile.size > 2 * 1024 * 1024) {
                    this.$message.error("文件大小不能超过2MB");
                    return false;
                }
                let result =  await this.validateForm();
                console.log("validateForm - 结果:", result);
                if (!result) {
                    return false;
                }

                this.isUploading = true;
                this.uploadProgress = 0;
                this.uploadError = '';

                try {
                    this.$message.info('正在上传到OSS...');
                    this.uploadProgress = 30;

                    // 1. 先上传到 OSS
                    const ossResult = await uploadToOSS(this.form.uploadFile,this.tenantId);
                    console.log("uploadToOSS - 结果:", ossResult);

                    if (ossResult.code === 200 && ossResult.data.success) {
                        this.uploadProgress = 70;
                        this.$message.success('OSS上传成功，正在触发后台处理...');

                        // 2. OSS 上传成功后，触发后台处理
                        const processResult = await triggerAnythingLLMProcess(
                            ossResult.data,
                            this.workspace_slug,
                            this.form.folder_name,
                            this.tenantId,
                            this.userName,
                            this.dirId,
                            this.form.uploadFile.size
                        );
                        console.log("processResult:", processResult);
                        if (processResult.data.code === 200) {
                            this.uploadProgress = 100;
                            this.$message.success("文件已上传到OSS，后台正在异步处理，您可以继续上传文档。");

                            // 延迟重置状态，让用户看到完成状态
                            setTimeout(() => {
                                this.$emit('submit-success', true);
                                this.removeFile();
                            }, 1000);

                            return true;
                        } else {
                            this.uploadError = "触发后台处理失败";
                            this.$message.error(this.uploadError);
                            this.$emit('submit-success', false);
                            return false;
                        }
                    } else {
                        this.uploadError = "OSS上传失败: " + (ossResult.message || '未知错误');
                        this.$message.error(this.uploadError);
                        this.$emit('submit-success', false);
                        return false;
                    }
                } catch (error) {
                    console.error("submitForm - 失败:", error);
                    this.uploadError = "上传失败: " + (error.message || '未知错误');
                    this.$message.error(this.uploadError);
                    this.$emit('submit-success', false);
                    return false;
                } finally {
                    this.isUploading = false;
                }
            },
        }
    }
    </script>

    <style scoped>
    .upload-container {
       position: relative;
       display: inline-block;
       width: 100%;
       height: 100%;
       border: 1px dashed #ccc;
       border-radius: 4px;
       background-color: #f5f5f5;
       }
       .required-asterisk{
         color: red;
         margin-left: 10px;
       }

       .file-input {
          display: none;
        }

        .upload-box {
        display: block;
        width: 100%;
        height: 120px;
        border: 2px dashed #474747;
        border-radius: 8px;
        background-color: rgba(240, 244, 249, 0.5);
        cursor: pointer;
        transition: all 0.3s;
        position: relative;
        overflow: hidden;

        &:hover {
            border-color: #00f0ff;
            background-color: rgba(#00f0ff, 0.05);
        }
    }
    .upload-placeholder {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        color: #999;
    }

    .plus-icon {
        font-size: 2rem;
        font-weight: lighter;
        margin-bottom: 8px;
        color: #00f0ff;
    }

    .upload-text {
        font-size: 0.9rem;
    }

    .file-preview {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      padding: 0 20px;
      position: relative;
      pointer-events: none;
     }

.file-icon {
  font-size: 1.5rem;
  margin-right: 10px;
}

.file-name {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 30px;
}

.remove-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #ff4d4f;
  color: white;
  border: none;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  pointer-events: auto; /* 但允许删除按钮接收点击事件 */

  &:hover {
    background: #ff7875;
  }
}
/* 上传状态样式 */
.upload-status {
  margin-top: 10px;
  padding: 8px 12px;
  border-radius: 4px;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
}

.uploading-text {
  color: #1890ff;
  display: flex;
  align-items: center;
  font-size: 14px;
}

.uploading-text i {
  margin-right: 6px;
  font-size: 16px;
}

.success-text {
  color: #52c41a;
  display: flex;
  align-items: center;
  font-size: 14px;
}

.success-text i {
  margin-right: 6px;
  font-size: 16px;
}

.error-text {
  color: #ff4d4f;
  display: flex;
  align-items: center;
  font-size: 14px;
}

.error-text i {
  margin-right: 6px;
  font-size: 16px;
}

/* 进度条自定义样式 */
:deep(.el-progress-bar) {
  padding-right: 0;
}

:deep(.el-progress__text) {
  font-size: 12px;
  min-width: 40px;
}
.preview-area{
    border: 2px dashed #474747;
}
</style>